import CircleIcon from "@mui/icons-material/Circle";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";
import { boxShadows, white } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
const PREFIX = "CommentsPinIcon";

const classes = {
	iconContainer: `${PREFIX}iconContainer`,
	iconOverlay: `${PREFIX}iconOverlay`,
	pinStyle: `${PREFIX}pinStyle`,
	typography: `${PREFIX}typography`,
};

const Root = styled("span")((
	{
		theme,
	},
) => ({
	[`&.${classes.iconContainer}`]: {
		boxShadow: boxShadows.iconButton,
		borderRadius: "12px",
		backgroundColor: white[50],
		marginRight: "2px",
	},
}));

export interface CommentsRevisionChipProps extends SvgIconProps {
	/** color of 3D pin */
	pinColor?: string;

	/** name of 3D pin */
	pinName?: string;
}

const CommentsPinIcon: FunctionComponent<CommentsRevisionChipProps> = observer((props) => {
	const { pinColor } = props;

	return (
		<Root className={classes.iconContainer}>
			<CircleIcon sx={{ color: pinColor, fontSize: "20px" }} />
		</Root>
	);
});

export default CommentsPinIcon;